
if (!customElements.get('color-links')) {
  class colorLinks extends HTMLElement {
    constructor() {
      super();

      this.list = this.querySelector('ul');
      this.url = this.dataset.url;
      this.id = this.dataset.id;
      this.collection = this.dataset.collection
      this.legend = this.closest('.product-form__input').querySelector('.form__label');

      this.fetchColorLinks();
    }

    fetchColorLinks() {
      fetch(this.url)
        .then(response => response.text())
        .then(data => {
          const parser = new DOMParser();
          const htmlDocument = parser.parseFromString(data, 'text/html');
          const swatches = htmlDocument.querySelectorAll('li');
          let activeId = '';

          if (swatches.length) {
            this.list.innerHTML = '';

            let swatchCount = 1;
            swatches.forEach(swatch => {
              const swatchLink = swatch.querySelector('a');
              const swatchInput = swatch.querySelector('input');
              const swatchLabel = swatch.querySelector('label');
              const swatchLabelText = swatchLabel.textContent
              const swatchInputId = `group-${this.id}-${this.collection}-${swatchCount}`;
              const swatchDataId = `${swatchInput.dataset.id}-${this.collection}`;

              swatchLabel.setAttribute('for', swatchInputId);
              swatchInput.name = this.id
              swatchInput.id = swatchInputId

              if (swatchDataId === this.id) {
                swatchInput.checked = true;
                activeId = swatchInput.dataset.image;

                this.legend.textContent = swatchLabelText
              }

              this.list.appendChild(swatch);

              swatchCount++;
            });
          };
        })
        .catch(error => console.error('Error fetching product swatches:', error));
    }
  }

  customElements.define('color-links', colorLinks);
}
